<template>
  <div class="discount-input">
    <fieldset class="form-group">
      <div class="row">
        <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
          {{ options.label }}
          <span v-if="options.required" class="required">*</span>
        </label>
        <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="discountType" id="amountType" value="amount" @change="selectType($event.target.value)" :checked="value.type === 'amount'">
            <label class="form-check-label" for="amountType">
              Amount ($)
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="discountType" id="percentType" value="percent" @change="selectType($event.target.value)" :checked="value.type === 'percent'">
            <label class="form-check-label" for="percentType">
              Percent (%)
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="none" id="none" value="none" @change="selectType()" :checked="!value.type || value.type === 'none'">
            <label class="form-check-label" for="none">
              None
            </label>
          </div>
          <currency-input v-if="value.type === 'amount'" :options="{ fullWidth: true }" :value="value.amount" @input="validate($event)"></currency-input>
          <number-input v-if="value.type === 'percent'" :options="{ fullWidth: true, maxVal: 100 }" :value="value.amount" @input="validate($event)"></number-input>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import CurrencyInput from '@/components/inputs/CurrencyInput'
import NumberInput from '@/components/inputs/NumberInput'
export default {
  name: 'DiscountInput',
  props: {
    value: {
      type: Object
    },
    options: {
      type: Object,
      default () {
        return {
          value: ''
        }
      }
    }
  },
  components: {
    CurrencyInput,
    NumberInput
  },
  data () {
    return {
      isValid: false,
      isDirty: false
    }
  },
  methods: {
    selectType (type) {
      this.$emit('input', {
        type: type,
        amount: '0'
      })
    },
    validate ($event) {
      this.$emit('input', {
        type: this.value.type,
        amount: $event
      })
      this.isValid = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DiscountInput.vue